export default "__VITE_ASSET__5fee6007__"